import { useRef, useEffect } from 'react';
const useIsMounted = () => {
  const mountedRef = useRef(true);
  useEffect(() => {
    const cleanup = () => {
      mountedRef.current = false;
    };
    return cleanup;
  }, []);
  return () => mountedRef.current;
};
export default useIsMounted;
//# sourceMappingURL=use-is-mounted.js.map